import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from 'react-fa'
import Assignee, { getFullNameForAssignee } from '../Assignee'
import './AssigneeRemoveButton.scss'

class AssigneeRemoveButton extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: props.expanded
    }
  }

  toggleOpenState = () => {
    if (!this.props.disableToggle) {
      this.setState((prevState) => ({ isOpen: !prevState.isOpen }))
    }
  }

  onDeleteClick = () => {
    this.toggleOpenState()
    this.props.removeTaskAssignment(this.props.assignment)
  }

  render() {
    const drawerClasses = classNames({
      'assignee-remove-button__assignee-name-drawer': true,
      'assignee-remove-button__assignee-name-drawer--open': this.state.isOpen
    })

    return (
      <div className='assignee-remove-button'>
        <div style={{ width: '0px', height: '0px', position: 'relative' }}>
          <div className='assignee-remove-button__assignee-background' />
          <Assignee
            onClick={this.toggleOpenState}
            assignment={this.props.assignment} />
        </div>
        <div className={drawerClasses}>
          <Icon
            className='assignee-remove-button__assignee-delete'
            name='remove'
            onClick={this.onDeleteClick}
            title={'Remove Assignee'} />
          <span className='assignee-remove-button__assignee-name'>
            {getFullNameForAssignee(this.props.assignment)}
          </span>
        </div>
      </div>
    )
  }
}

AssigneeRemoveButton.defaultProps = {
  expanded: false,
  disableToggle: false,
}

AssigneeRemoveButton.propTypes = {
  assignment: PropTypes.object.isRequired,
  removeTaskAssignment: PropTypes.func.isRequired,
  expanded: PropTypes.bool,
  disableToggle: PropTypes.bool,
}

export default AssigneeRemoveButton



// WEBPACK FOOTER //
// ./src/components/AssigneeRemoveButton/AssigneeRemoveButton.js